module.exports = __webpack_public_path__ + "img/KSC02881.9c70e9fe.jpg";